import { EnglishTranslation } from "translation/english/translation";

export function t(key) {
  if (key in EnglishTranslation) {
    return EnglishTranslation[key];
  }
  return ""
}